import { render, staticRenderFns } from "./setting-drawer.vue?vue&type=template&id=581c93ec&"
import script from "./setting-drawer.vue?vue&type=script&lang=js&"
export * from "./setting-drawer.vue?vue&type=script&lang=js&"
import style0 from "./setting-drawer.vue?vue&type=style&index=0&id=581c93ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports